"use strict";

exports.__esModule = true;
exports["default"] = exports.createTransition = void 0;

var createTransition = function createTransition(props, _temp) {
  if (props === void 0) {
    props = ['all'];
  }

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 100 : _ref$duration,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? 'ease-in-out' : _ref$easing;

  return props.map(function (prop) {
    return prop + " " + duration + "ms " + easing;
  }).join(', ');
};

exports.createTransition = createTransition;
var _default = {
  create: createTransition
};
exports["default"] = _default;